import '/assets/css/style.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '/assets/js/carousel.js'
import '/assets/js/navbar.js'
import '/assets/js/map.js'
